import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { prettyJson } from '../../utils/data_reports.utils';
export const SampleReports = ({ reports, setJsonValue, setQuery, setChartType, }) => {
    const onClick = (report) => {
        setJsonValue(prettyJson(report.query));
        setQuery(report.query);
        setChartType(report.chartType);
    };
    return (_jsxs("div", { className: 'flex flex-col gap-4 p-4', children: [_jsx("h4", { children: "Sample Reports" }), _jsx("ul", { children: reports.map((report) => (_jsx("li", { children: _jsx("span", { className: 'text-blue-500 cursor-pointer', onClick: () => onClick(report), children: report.title }) }, report.title))) })] }));
};
